import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import { useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { KETQUABAOVE_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { loaiDanhGiaValue } from '../../../../utils/define';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import moment from 'moment';

const FieldDisplayFile = ({ label, value }) => {
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    let files = [];
    if (value) {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                files = parsed;
            } else {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        } catch (e) {
            files = [{ filePath: value, name: value.split('/').pop() }];
        }
    }

    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div className="d-flex flex-wrap">
                {files.length > 0 ? (
                    files.map((file, idx) => {
                        const path = file.filePath || file;
                        let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                        return (
                            <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                <i className="fas fa-paperclip mr-1"></i> {name}
                            </a>
                        );
                    })
                ) : (
                    <span className="text-muted small">Không có file</span>
                )}
            </div>
        </Form.Group>
    );
};

const FieldDisplay = ({ label, value }) => {
    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div>
                <span className="text-dark" style={{ fontSize: '15px', fontWeight: 600 }}>
                    {value !== null && value !== undefined && value !== '' ? value : <span className="text-muted font-italic" style={{ fontWeight: 'normal' }}>Chưa cập nhật</span>}
                </span>
            </div>
        </Form.Group>
    );
};

const KetQuaBaoVeForm = ({ baoVeLuanAnCoSoId, readOnly = false, isUserView = false, hoSoId, onDataLoaded, onSaveSuccess }) => {
    const queryClient = useQueryClient();
    const [saving, setSaving] = useState(false);
    
    const [ketQuaBaoVeId, setKetQuaBaoVeId] = useState(null);
    const [soPhienHop, setSoPhienHop] = useState('');
    const [soThanhVien, setSoThanhVien] = useState('');
    const [danhGia, setDanhGia] = useState(loaiDanhGiaValue.dat);
    const [isBienBanHop, setIsBienBanHop] = useState(true);
    const [isDuChuKy, setIsDuChuKy] = useState(true);
    const [ngayHop, setNgayHop] = useState('');
    const [soBanNhanXet, setSoBanNhanXet] = useState('');
    const [soPhieuNhanXet, setSoPhieuNhanXet] = useState('');
    const [isQuyetDinh, setIsQuyetDinh] = useState(true);
    const [ghiChuQuyetDinh, setGhiChuQuyetDinh] = useState('');
    const [soPhieuThong, setSoPhieuThong] = useState('');
    const [isSuaTenDeTai, setIsSuaTenDeTai] = useState(true);
    const [tenDeTaiMoi, setTenDeTaiMoi] = useState('');
    const [isDieuChinhMucTieu, setIsDieuChinhMucTieu] = useState(true);
    const [ghiChuDieuChinh, setGhiChuDieuChinh] = useState('');
    const [soLuongBanGhi, setSoLuongBanGhi] = useState('');
    const [isXacNhanCanBo, setIsXacNhanCanBo] = useState(true);
    const [fileBienBanHop, setFileBienBanHop] = useState('');


    const { data: queryRes, refetch, isLoading } = useQuery(
        ['ketQuaBaoVeData', baoVeLuanAnCoSoId], 
        () => Get(`${KETQUABAOVE_API.GET_BY_BAOVE_ID}/${baoVeLuanAnCoSoId}`),
        { 
            enabled: !!baoVeLuanAnCoSoId,
            refetchOnWindowFocus: false 
        }
    );



    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setKetQuaBaoVeId(item.id);
                setSoPhienHop(item.soPhienHop || '');
                setSoThanhVien(item.soThanhVien || '');
                setDanhGia(item.danhGia || loaiDanhGiaValue.dat);
                setIsBienBanHop(item.isBienBanHop || false);
                setIsDuChuKy(item.isDuChuKy || false);
                setNgayHop(item.ngayHop ? moment(item.ngayHop).format('YYYY-MM-DD') : '');
                setSoBanNhanXet(item.soBanNhanXet || '');
                setSoPhieuNhanXet(item.soPhieuNhanXet || '');
                setIsQuyetDinh(item.isQuyetDinh || false);
                setGhiChuQuyetDinh(item.ghiChuQuyetDinh || '');
                setSoPhieuThong(item.soPhieuThong || '');
                setIsSuaTenDeTai(item.isSuaTenDeTai || false);
                setTenDeTaiMoi(item.tenDeTaiMoi || '');
                setIsDieuChinhMucTieu(item.isDieuChinhMucTieu || false);
                setGhiChuDieuChinh(item.ghiChuDieuChinh || '');
                setSoLuongBanGhi(item.soLuongBanGhi || '');
                setIsXacNhanCanBo(item.isXacNhanCanBo || false);
                setFileBienBanHop(item.fileBienBanHop || '');
                
                if (onDataLoaded) onDataLoaded(true);
            } else {
                if (onDataLoaded) onDataLoaded(false);
            }
        } else if (queryRes === null) {
            if (onDataLoaded) onDataLoaded(false);
        }
    }, [queryRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                BaoVeLuanAnCoSoId: baoVeLuanAnCoSoId,
                SoPhienHop: soPhienHop || '',
                SoThanhVien: soThanhVien ? parseInt(soThanhVien) : null,
                DanhGia: danhGia,
                IsBienBanHop: isBienBanHop,
                IsDuChuKy: isDuChuKy,
                NgayHop: ngayHop || null,
                SoBanNhanXet: soBanNhanXet ? parseInt(soBanNhanXet) : null,
                SoPhieuNhanXet: soPhieuNhanXet ? parseInt(soPhieuNhanXet) : null,
                IsQuyetDinh: isQuyetDinh,
                GhiChuQuyetDinh: isQuyetDinh ? (ghiChuQuyetDinh || '') : null,
                SoPhieuThong: soPhieuThong ? parseInt(soPhieuThong) : null,
                IsSuaTenDeTai: isSuaTenDeTai,
                TenDeTaiMoi: isSuaTenDeTai ? (tenDeTaiMoi || '') : null,
                IsDieuChinhMucTieu: isDieuChinhMucTieu,
                GhiChuDieuChinh: isDieuChinhMucTieu ? (ghiChuDieuChinh || '') : null,
                SoLuongBanGhi: soLuongBanGhi ? parseInt(soLuongBanGhi) : null,
                IsXacNhanCanBo: isXacNhanCanBo,
                FileBienBanHop: fileBienBanHop || ''
            };

            if (ketQuaBaoVeId) {
                await Put(KETQUABAOVE_API.UPDATE_ITEM, ketQuaBaoVeId, { ...payload, Id: ketQuaBaoVeId });
            } else {
                await Post(KETQUABAOVE_API.CREATE, null, payload);
            }

            toast.success('Lưu thông tin thành công!');
            
            queryClient.invalidateQueries(['baoVeLuanAnCoSoData']);
            queryClient.invalidateQueries(['baoVeCoSoData']);
            queryClient.invalidateQueries(['duyetBaoVeCoSoData']);
            queryClient.invalidateQueries(['deCuongDaoTao']);
            queryClient.invalidateQueries(['hoSoNCSDetail']);
            queryClient.invalidateQueries(['lichSuThayDoi']);
            queryClient.invalidateQueries(['deCuongTS']);
            
            await refetch();
            if (onSaveSuccess) onSaveSuccess();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;



    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Tổ chức đánh giá luận án cấp cơ sở</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Số phiên họp HĐ cấp cơ sở</>} value={soPhienHop} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Số phiên họp HĐ cấp cơ sở</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={soPhienHop}
                                        onChange={(e) => setSoPhienHop(e.target.value)}
                                        placeholder="Nhập số phiên họp..."
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Số thành viên tham gia phiên họp</>} value={soThanhVien} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Số thành viên tham gia phiên họp</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soThanhVien}
                                        onChange={(e) => setSoThanhVien(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số thành viên..."
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">3.</span> Đánh giá tổ chức đánh giá luận án cấp cơ sở theo quy định</>} value={danhGia === loaiDanhGiaValue.dat ? 'Đạt' : 'Không đạt'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Đánh giá tổ chức đánh giá luận án cấp cơ sở theo quy định</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Đạt"
                                            name="danhGia"
                                            checked={danhGia === loaiDanhGiaValue.dat}
                                            onChange={() => setDanhGia(loaiDanhGiaValue.dat)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không đạt"
                                            name="danhGia"
                                            checked={danhGia === loaiDanhGiaValue.khongDat}
                                            onChange={() => setDanhGia(loaiDanhGiaValue.khongDat)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-success shadow-sm">
                <Card.Header className="bg-success text-white font-weight-bold">2. Hồ sơ buổi bảo vệ luận án cấp cơ sở</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Biên bản họp</>} value={isBienBanHop ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Biên bản họp</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isBienBanHop"
                                            checked={isBienBanHop === true}
                                            onChange={() => setIsBienBanHop(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isBienBanHop"
                                            checked={isBienBanHop === false}
                                            onChange={() => setIsBienBanHop(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Biên bản họp đủ chữ ký của Chủ tịch và Thư ký</>} value={isDuChuKy ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Biên bản họp đủ chữ ký của Chủ tịch và Thư ký</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDuChuKy"
                                            checked={isDuChuKy === true}
                                            onChange={() => setIsDuChuKy(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDuChuKy"
                                            checked={isDuChuKy === false}
                                            onChange={() => setIsDuChuKy(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">3.</span> Ngày họp</>} value={ngayHop ? moment(ngayHop).format('DD/MM/YYYY') : ''} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Ngày họp</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={ngayHop}
                                        onChange={(e) => setNgayHop(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">4.</span> Số bản nhận xét luận án</>} value={soBanNhanXet} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Số bản nhận xét luận án</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soBanNhanXet}
                                        onChange={(e) => setSoBanNhanXet(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số bản nhận xét..."
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">5.</span> Số phiếu nhận xét</>} value={soPhieuNhanXet} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">5.</span> Số phiếu nhận xét</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soPhieuNhanXet}
                                        onChange={(e) => setSoPhieuNhanXet(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số phiếu nhận xét..."
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">6.</span> Quyết định của hội đồng</>} value={isQuyetDinh ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">6.</span> Quyết định của hội đồng</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isQuyetDinh"
                                            checked={isQuyetDinh === true}
                                            onChange={() => setIsQuyetDinh(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isQuyetDinh"
                                            checked={isQuyetDinh === false}
                                            onChange={() => setIsQuyetDinh(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        {isQuyetDinh && (
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Ghi chú quyết định của Hội đồng" value={ghiChuQuyetDinh} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Ghi chú quyết định của Hội đồng</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        value={ghiChuQuyetDinh}
                                        onChange={(e) => setGhiChuQuyetDinh(e.target.value)}
                                        placeholder="Nhập ghi chú quyết định..."
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">7.</span> Số phiếu đồng ý thông qua luận án</>} value={soPhieuThong} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">7.</span> Số phiếu đồng ý thông qua luận án</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soPhieuThong}
                                        onChange={(e) => setSoPhieuThong(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số phiếu đồng ý thông qua luận án..."
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">8.</span> Điều chỉnh tên đề tài</>} value={isSuaTenDeTai ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">8.</span> Điều chỉnh tên đề tài</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isSuaTenDeTai"
                                            checked={isSuaTenDeTai === true}
                                            onChange={() => setIsSuaTenDeTai(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isSuaTenDeTai"
                                            checked={isSuaTenDeTai === false}
                                            onChange={() => setIsSuaTenDeTai(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        {isSuaTenDeTai && (
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Tên đề tài mới" value={tenDeTaiMoi} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Tên đề tài mới</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tenDeTaiMoi}
                                        onChange={(e) => setTenDeTaiMoi(e.target.value)}
                                        placeholder="Nhập tên đề tài mới..."
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">9.</span> Điều chỉnh mục tiêu nghiên cứu</>} value={isDieuChinhMucTieu ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">9.</span> Điều chỉnh mục tiêu nghiên cứu</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDieuChinhMucTieu"
                                            checked={isDieuChinhMucTieu === true}
                                            onChange={() => setIsDieuChinhMucTieu(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDieuChinhMucTieu"
                                            checked={isDieuChinhMucTieu === false}
                                            onChange={() => setIsDieuChinhMucTieu(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        {isDieuChinhMucTieu && (
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Ghi chú điều chỉnh mục tiêu nghiên cứu" value={ghiChuDieuChinh} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Ghi chú điều chỉnh mục tiêu nghiên cứu</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        value={ghiChuDieuChinh}
                                        onChange={(e) => setGhiChuDieuChinh(e.target.value)}
                                        placeholder="Nhập ghi chú điều chỉnh mục tiêu nghiên cứu..."
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}

                        <div className="w-100"></div>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">10.</span> Số lượng bản giải trình các điểm đã bổ sung và sửa chữa của NCS sau mỗi phiên họp Hội đồng (theo số phiên họp)</>} value={soLuongBanGhi} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">10.</span> Số lượng bản giải trình các điểm đã bổ sung và sửa chữa của NCS sau mỗi phiên họp Hội đồng (theo số phiên họp)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soLuongBanGhi}
                                        onChange={(e) => setSoLuongBanGhi(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số lượng bản giải trình..."
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">11.</span> Chất lượng bản giải trình: Có xác nhận của CBHD và các thành viên trong Hội đồng</>} value={isXacNhanCanBo ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">11.</span> Chất lượng bản giải trình: Có xác nhận của CBHD và các thành viên trong Hội đồng</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isXacNhanCanBo"
                                            checked={isXacNhanCanBo === true}
                                            onChange={() => setIsXacNhanCanBo(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isXacNhanCanBo"
                                            checked={isXacNhanCanBo === false}
                                            onChange={() => setIsXacNhanCanBo(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12}>
                            {readOnly || isUserView ? (
                                <FieldDisplayFile label={<><span className="text-danger">12.</span> File Biên bản họp</>} value={fileBienBanHop} />
                            ) : (
                                <Form.Group>
                                    <DocumentInput
                                        labelTitle={<><span className="text-danger">12.</span> File Biên bản họp</>}
                                        value={fileBienBanHop}
                                        onChangeProp={(url) => setFileBienBanHop(url)}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave()} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                </div>
            )}
        </div>
    );
};

export default KetQuaBaoVeForm;
